import {Component, OnDestroy} from '@angular/core';
import {DocumentModel} from "../../../model/document.model";
import {ActivatedRoute, Router} from "@angular/router";
import {delay, first, map, Subject, takeUntil, tap} from "rxjs";
import {DmxDocumentService} from "../../../service/http/dmx-document.service";
import {DocumentDetailActionComponent} from "./document-detail-action/document-detail-action.component";
import {LayoutElementUtil} from "../../../service/layout/layout-element.service";
import {ObservableWrapper} from "../../util/observable-wrapper";
import {MatDialog} from "@angular/material/dialog";
import {RfaStore} from "../../../store/rfa/rfa.store";
import {EventService} from "../../../service/event.service";
import {DocumentDetailElementsComponent} from './document-detail-elements/document-detail-elements.component';
import {MatTabsModule} from '@angular/material/tabs';
import {NgIf, NgFor, NgTemplateOutlet, AsyncPipe} from '@angular/common';
import {LoadingErrorComponent} from '../../common/loading/loading-error/loading-error.component';
import {P_DOCUMENTS} from "../../../app.routes";
import {fadeIn} from "../../../animations/animations";
import {Container, KiButton, KiButtonMapping, Tab, TextArea} from "../../../model/layout.model";
import {ProgressbarService} from "../../../service/progressbar.service";
import {EventBusService} from "../../../service/event-bus.service";
import {KiRefreshEvent} from "../../../model/event-bus.model";
import {EventBusTypes} from "../../../model/constants";


@Component({
  selector: 'app-document-detail',
  templateUrl: './document-detail.component.html',
  styleUrls: ['./document-detail.component.scss'],
  animations: [fadeIn],
  standalone: true,
  imports: [
    LoadingErrorComponent,
    NgIf,
    MatTabsModule,
    NgFor,
    NgTemplateOutlet,
    DocumentDetailElementsComponent,
    AsyncPipe,
  ],
})
export class DocumentDetailComponent implements OnDestroy {

  public wetterTerminalDocumentWrapper: ObservableWrapper<DocumentModel> | null = null;
  public selectedTabIndex: number = 0;

  public documentId: string = 'new';
  public selectedRfaKuerzel!: string;
  public readOnly: boolean = false;

  private destroyer$: Subject<boolean> = new Subject<boolean>();

  constructor(private activatedRoute: ActivatedRoute, private readonly restService: DmxDocumentService,
              private dialog: MatDialog, private eventService: EventService,
              private rfaStore: RfaStore, private route: Router, public layoutElementUtil: LayoutElementUtil,
              private progressbarService: ProgressbarService,
              private eventBusService: EventBusService) {

    //ABBONEIREN AUF DIE ÄNDERUNG DER AUSGEWÄHLTEN RFA
    this.rfaStore.getSelectedRfa().pipe(takeUntil(this.destroyer$), map((rundfunkanstalt) => {
      if (rundfunkanstalt) {
        this.selectedRfaKuerzel = rundfunkanstalt.kuerzel;
        console.log("CONSTRUCTOR DocumentDetailComponent: " + this.selectedRfaKuerzel);
        //ABBONNIERT SICH AUF DIE ROUTE UND BEZIEHT AUS DEN PARAMS DIE DOCUMENTID & GGF. DAS COPYPROFILE
        this.activatedRoute.queryParams
          .pipe(takeUntil(this.destroyer$))
          .subscribe({

            next: params => this.getDocument(this.documentId = params['documentId'], params['copyProfile'])
            ,
            error: err => console.error(`ERROR: fetching queryParams for documentId`, err),
          });
      }
    })).subscribe();


    //ABBONNIERT SICH AUF DEN EVENTSERVICE UND ÖFFNET DAS ACTION SHEET
    this.eventService.getShowPublishActions().pipe(takeUntil(this.destroyer$)).subscribe({
      next: (data) => {
        if (data.show) this.showActions();
      }
    });

    this.eventBusService.on$<KiRefreshEvent>(EventBusTypes.KI_REFRESH_EVENT.valueOf()).pipe(takeUntil(this.destroyer$)).subscribe(kiRefreshEvent => {
      this.wetterTerminalDocumentWrapper?.data$.pipe(takeUntil(this.destroyer$)).subscribe({
        next: (document) => {
          //console.log('KI-REFRESH-EVENT: '+ JSON.stringify(kiRefreshEvent));
          document.tabs.forEach((tab: Tab) => {
            let kiButtonContainer:Container|null = this.findContainerByContainerType(tab, 'KiButton');
            if(kiButtonContainer && this.layoutElementUtil.isKiButton(kiButtonContainer)) {
              //console.log('KI-REFRESH-EVENT KI-BUTTON FOUND: '+ JSON.stringify(c));

              const kiButton:KiButton = this.layoutElementUtil.asKiButton(kiButtonContainer);
              if(kiButton) {
                const kiButtonMappings:KiButtonMapping[] | undefined = kiButton.kiButtonMappings;
                if (kiButtonMappings && kiButtonMappings.length > 0) {
                  //console.log("FIRE_KI_REFRESH_EVENT KI--BUTTON-MAPPING: " + JSON.stringify(kiButtonMappings));
                  let mapping:KiButtonMapping|undefined = kiButtonMappings.find(value => value.to === kiRefreshEvent.containerId);
                  if(mapping) {
                    let kiButtonMappings2:KiButtonMapping[] = [];
                    if(kiRefreshEvent.shortened) {
                      //console.log("MAPPING GEHT, WEIL SHORTENED ");
                      let maxChars:number = Number.parseInt(mapping.max_chars);
                      maxChars = maxChars - Math.round(maxChars/10);
                      //mapping.max_chars = maxChars.toString();
                      let newMapping:KiButtonMapping|undefined = {
                        from:mapping.from,
                        to:mapping.to,
                        max_chars:maxChars.toString(),
                        maxRetries:mapping.maxRetries,
                        reduceMaxChars:mapping.reduceMaxChars,
                        zusatzinfo:mapping.zusatzinfo
                      }
                      kiButtonMappings2.push(newMapping);
                      //console.log("MAPPING MAX_CHARS: " + mapping.max_chars + " MAXCHARS: " + maxChars);
                    } else {
                      kiButtonMappings2.push(mapping);
                    }

                    //console.log("MAPPING: " + JSON.stringify(mapping) + "CONTAINERID: " + event.containerId + " SHORTEND: " + event.shortened);
                    this.doKiEvent(kiButtonMappings2, document.tabs);
                  }
                }
              }
            }
          })
        }
      });
    });

    this.eventBusService.on$<KiButtonMapping[]>(EventBusTypes.KI_BUTTON_EVENT.valueOf()).pipe(takeUntil(this.destroyer$)).subscribe(kiButtonMappings => {
      this.wetterTerminalDocumentWrapper?.data$.pipe(takeUntil(this.destroyer$)).subscribe({
        next: (document) => {
          this.doKiEvent(kiButtonMappings, document.tabs);
        }
      });
    })
  }

  ngOnDestroy() {
    if (!this.destroyer$.closed) {
      this.destroyer$.next(true);
      this.destroyer$.unsubscribe();
    }
  }

  /**
   * Wenn die documentId === "new", dann wird ein neues Dokument erstellt bzw. ein leeres Template geholt
   * @param documentId
   * @private
   */
  private getDocument(documentId: string, copyProfile?: string) {
    this.wetterTerminalDocumentWrapper = new ObservableWrapper(this.restService.loadDocumentById(this.selectedRfaKuerzel, documentId, copyProfile)
      .pipe(first(), tap((data) => this.documentId = data.header.documentId as string)));
  }

  showActions() {
    this.wetterTerminalDocumentWrapper?.data$.subscribe({
      next: (document) => this.openActionSheet(document)
    });
  }

  /**
   * Öffnet das ActionSheet/Veröffentlichungsmenü für das Dokument
   * @param document
   * @private
   */
  private openActionSheet(document: DocumentModel) {

    const actionSheet = this.dialog.open(DocumentDetailActionComponent, {
      width: '750px',
      height: '500px',
      closeOnNavigation: true,
      data: {
        wetterTerminalDocument: document,
        workflowFilterCodes: document.tabs[this.selectedTabIndex].workflowFilterCodes,
      }
    });

    actionSheet.afterClosed().pipe(first()).subscribe({
      next: (value) => {
        if (value) this.route.navigate([`${P_DOCUMENTS}/${this.selectedRfaKuerzel}`]);
      }
    });
  }

  reload = () => this.getDocument(this.documentId);
  protected readonly indexedDB = indexedDB;

  public getIndexOfNonTabElement(tab:Tab):number {

    if(tab.containerList && tab.containerList.length > 0 && tab.containerList[0].containerType === 'Tab') {
      for(let i = 0; i<tab.containerList.length; i++) {
        if(tab.containerList[i].containerType !== 'Tab') {
          return i;
        }
      }
    }
    return -1;
  }

  doKiEvent(kiButtons: KiButtonMapping[], tabs:Tab[]|undefined) {
    let counter:number = 0;
    //console.log("KI-BUTTON_MAPPING: " + JSON.stringify(kiButtons))
    this.progressbarService.startShowProgressbar(kiButtons.length);
    this.progressbarService.onLoading(counter);
    kiButtons.forEach(button => {
      tabs?.forEach((tab:Tab) => {
        let sourceContainer:Container|null = this.findContainerById(tab, button.from);
        if(sourceContainer && this.layoutElementUtil.isTextArea(sourceContainer)) {
          let content:string|undefined = this.layoutElementUtil.asTextArea(sourceContainer).content;
          if(content && content.length > 0) {
            this.restService.getKiTextForHessenwetter(content, button).subscribe({
              next: response => {
                //console.log("KI Ergebnis: " + JSON.stringify(response));
                this.setTextInKiVtxNacht(response, tabs, button.to);
              },
              error: err => {
                console.log("So ein Fuck: " + JSON.stringify(err));
                this.progressbarService.onError("Kann Box '" + button.to + "' nicht füllen.");
              }, complete: () => {
                counter++;
                this.progressbarService.onLoading(counter);
                if(counter >= kiButtons.length) {
                  this.progressbarService.stopShowProgressbar();
                }
                console.log("The KI observable is now completed.");
              }
            });
          }
        }
      })
    });
  }

  private setTextInKiVtxNacht(text:string, tabs:Tab[], containerId:string) {
    if(tabs && tabs.length > 0) {
      tabs.forEach(tab => {
        if (tab && tab.containerType === 'Tab' && tab.caption === 'KI-Videotext') {
          tab.containerList?.forEach(section => {
            if (section.containerType === 'Section') {
              if (section) {
                let containerList: Container[] | undefined = section.containerList;
                if (containerList) {
                  //console.log("SECTION CONTAINERLIST: " + JSON.stringify(section.containerList));
                  let hessenwetterNachtContainer = containerList.find(container => container.containerId === containerId);
                  if (hessenwetterNachtContainer) {
                    const textArea = this.layoutElementUtil.asTextArea(hessenwetterNachtContainer);
                    textArea.content = text;
                  }
                }
              }
            }
          })
        }
      })
    }

  }

  getLokalzeitenEvent(ws: String[], ac: Container, lokalzeiten: Container) {
    if (ac && lokalzeiten && ws.length > 0) {
      ws.forEach(w => {
        let ids = w.split(',');
        if (ids.length == 2) {
          let textToCopyFrom: string | undefined;
          ac.containerList?.forEach(container => {
            if (container.containerType === 'Section' && container.caption === 'TV Vorhersage') {
              container.containerList?.forEach(c => {
                c.containerList?.forEach(co => {
                  if (this.layoutElementUtil.isTextArea(co) && co.containerId === ids[0]) {
                    textToCopyFrom = this.layoutElementUtil.asTextArea(co).content;
                  }
                })
              });
            }
          })
          if (textToCopyFrom) {
            lokalzeiten.containerList?.forEach(subtab => {
              if (subtab.caption != ac.caption) {
                const tab = this.layoutElementUtil.asTab(subtab);
                if (tab) {
                  tab.containerList?.forEach(container => {
                    if (container.containerType === 'Section' && container.caption === 'TV Vorhersage') {
                      container.containerList?.forEach(c => {
                        if (this.layoutElementUtil.isTextArea(c) && c.containerId === ids[1]) {
                          const textArea = this.layoutElementUtil.asTextArea(c);
                          textArea.content = textToCopyFrom;
                        }
                      });
                    }
                  });
                }
              }
            })
          }
        }
      })
    }
  }

  findContainerByContainerType(root: Container, target:string): Container | null {
    // 1. Check if the current node is the one we're looking for
    if (root.containerType === target) {
      return root;
    }

    // 2. If it has children, search through them
    if (root.containerList && root.containerList.length > 0) {
      for (const child of root.containerList) {
        const found = this.findContainerByContainerType(child, target);

        // 3. If the recursive call found the node, bubble it up
        if (found) {
          return found;
        }
      }
    }

    // 4. Return null if nothing was found in this branch
    return null;
  }

  findContainerById(root: Container, targetId: string): Container | null {
    // 1. Check if the current node is the one we're looking for
    if (root.containerId === targetId) {
      return root;
    }

    // 2. If it has children, search through them
    if (root.containerList && root.containerList.length > 0) {
      for (const child of root.containerList) {
        const found = this.findContainerById(child, targetId);

        // 3. If the recursive call found the node, bubble it up
        if (found) {
          return found;
        }
      }
    }

    // 4. Return null if nothing was found in this branch
    return null;
  }

  protected readonly Object = Object;
}
